import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7098b2d9 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3ad204de = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _095267b4 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _53a39bea = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _7300d88a = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _b3becca8 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _5f382d6a = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _97b31876 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _37db46e4 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _246bf7a2 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _b0c7dc7a = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _501e8d2d = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _22de9a33 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _2ca7e08a = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _a36b08fc = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _07f016ed = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _23355694 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _635d31ca = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _03cb6d51 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _050ebcb1 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _516f2c74 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _597a63e8 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _1844169c = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _9990b35e = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _0875c252 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _153e1aae = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _79c23720 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _19b69fd2 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _1343ccb0 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _6a8c9c38 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _03a5926f = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _6a974ebe = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _ba11606a = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _731f7f03 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _75026005 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _d90dfa82 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _48fe53cc = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _5e9086a4 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _2d0c309a = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _878fe7d4 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _652ccc16 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _496df922 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _53efd946 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _54690f20 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _3d664e73 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _80232282 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _cc20972e = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _645ab503 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _00bdf1cb = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _70cd3a09 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _2060ca50 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _63b78c18 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _31ad67c7 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _66ff8c39 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4287416c = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _849da35e = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _3f637c72 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _025e63a6 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _6629db58 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _74b44303 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _3f7dfc32 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _1bae6eba = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _71c66e1a = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _4377662b = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _e4bcd1fc = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _70379781 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _5dfec71c = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _ed1b7d34 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0d1f7572 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _0e0a2a76 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _6f79a8eb = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _d9a860ba = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _478dd4b7 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _c258e736 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _7fb2ce33 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _5657f6d5 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _7098b2d9,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3ad204de,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _095267b4,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _53a39bea,
    name: "calendar"
  }, {
    path: "/customer",
    component: _7300d88a,
    name: "customer"
  }, {
    path: "/details",
    component: _b3becca8,
    name: "details"
  }, {
    path: "/goals",
    component: _5f382d6a,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _97b31876,
    name: "maisoku"
  }, {
    path: "/media",
    component: _37db46e4,
    name: "media"
  }, {
    path: "/privacy",
    component: _246bf7a2,
    name: "privacy"
  }, {
    path: "/project",
    component: _b0c7dc7a,
    name: "project"
  }, {
    path: "/response",
    component: _501e8d2d,
    name: "response"
  }, {
    path: "/sale",
    component: _22de9a33,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _2ca7e08a,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _a36b08fc,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _07f016ed,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _23355694,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _635d31ca,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _03cb6d51,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _050ebcb1,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _516f2c74,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _597a63e8,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _1844169c,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _9990b35e,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _0875c252,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _153e1aae,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _79c23720,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _19b69fd2,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _1343ccb0,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _6a8c9c38,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _03a5926f,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _6a974ebe,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _ba11606a,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _731f7f03,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _75026005,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _d90dfa82,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _48fe53cc,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _5e9086a4,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _2d0c309a,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _878fe7d4,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _652ccc16,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _496df922,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _53efd946,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _54690f20,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _3d664e73,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _80232282,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _cc20972e,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _645ab503,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _00bdf1cb,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _70cd3a09,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _2060ca50,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _63b78c18,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _31ad67c7,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _66ff8c39,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _4287416c,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _849da35e,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _3f637c72,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _025e63a6,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _6629db58,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _74b44303,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _3f7dfc32,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _1bae6eba,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _71c66e1a,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _4377662b,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _e4bcd1fc,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _70379781,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _5dfec71c,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _ed1b7d34,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0d1f7572,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _0e0a2a76,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _6f79a8eb,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _d9a860ba,
    name: "property-property",
    children: [{
      path: "contact",
      component: _478dd4b7,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _c258e736,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _7fb2ce33,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _5657f6d5,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
